/** Homepage, social, and tagline copy — three levels of messaging. */

export const BRAND_TAGLINE = 'Performance over popularity.';

export const HOMEPAGE = {
  title: 'Independent Performance Ratings for Sports Betting Experts',
  titleAccent: undefined as string | undefined,
  hook: 'See who consistently performs—not who markets themselves best.',
  subtitle:
    'Stop relying on screenshots, hot streaks, and self-reported records. WagerWatchdog independently tracks public and paid picks, measures long-term performance, and rates experts using objective data.',
  primaryCta: 'Browse Expert Ratings',
  secondaryCta: 'Claim Your Profile',
} as const;

export const PAGE_META = {
  title: 'WagerWatchdog — Independent Performance Ratings for Sports Betting Experts',
  description:
    'Independent performance ratings for sports betting experts. Every pick tracked, every outcome verified—see who actually performs over the long term.',
} as const;

export const MEET_WCS = {
  eyebrow: 'Win-rate skill',
  heading: 'Meet WCS',
  subheading: 'The WagerWatchdog Credibility Score',
  body: 'WCS measures how skilled an expert is at picking winners—consistency, sample size, and historical win-rate quality. It is not the same as profitability.',
  analogy: 'Think of WCS as a credit score for betting expertise.',
  footnote: 'Higher WCS = stronger long-term picking skill.',
  learnMoreHref:
    'https://docs.wagerwatchdog.com/articles/0308146-watchdog-credibility-score-wcs-explained',
  learnMoreLabel: 'How we calculate WCS',
} as const;

export const MEET_PR = {
  eyebrow: 'Profitability score',
  heading: 'Meet PR',
  subheading: 'Profit Rating',
  body: 'PR answers the money question: if you tailed every pick, would you come out ahead? It uses modeled ROI on a 0–99 scale where 50 is break-even.',
  analogy: 'WCS grades picking skill. PR grades whether following those picks pays off.',
  footnote:
    'Leaderboards sort by Profit Rating (PR): who would have made you money if you followed every pick—not who has the best win rate (WCS).',
} as const;

export const SOCIAL_BIOS = {
  x: [
    'Independent performance ratings for sports betting experts.',
    'Every pick. Every outcome. Nothing hidden.',
  ],
  instagram: [
    'The independent rating system for sports betting experts.',
    '📈 Performance over popularity.',
    '👇 Browse expert ratings.',
  ],
  tiktok: [
    'Stop trusting betting screenshots.',
    'We measure what experts actually do.',
  ],
  linkedin:
    'Independent performance ratings for sports betting experts. Every pick tracked, every outcome verified.',
  discord: [
    'The independent source for sports betting expert ratings.',
    'Track performance. Discover experts. Discuss the data.',
  ],
} as const;

export const TAGLINES = {
  tier1: [
    'Performance over popularity.',
    'Reputation is claimed. Performance is measured.',
    "Don't trust betting records. Verify them.",
    'Independent performance ratings for sports betting experts.',
    'Every pick. Every outcome. Nothing hidden.',
  ],
} as const;
